import { Component, Input, OnInit } from '@angular/core';
import { PayrollClassItem, PayrollInstructorSummary } from '../../../models/payroll-report-model';

@Component({
    selector: 'app-payroll-report-item',
    templateUrl: './payroll-report-item.component.html',
    styleUrls: ['./payroll-report-item.component.scss'],
    standalone: false
})
export class PayrollReportItemComponent implements OnInit {
    @Input()
    summaryItem: PayrollInstructorSummary;
    constructor() {}

    ngOnInit() {}
    public attendanceProvided(item: PayrollClassItem) {
        return item.classAttendance !== null;
    }
}
